/**
 * @generated SignedSource<<d76cb7bc944a83003af154e4fcf5012b>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderInlineDataFragment } from 'relay-runtime';
export type VerticalType = "art" | "fashion" | "furniture" | "jewelry" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type shippingHelpers_item$data = {
  readonly shipmentQuotes: ReadonlyArray<{
    readonly isCalculated: boolean | null;
    readonly isComplimentary: boolean | null;
    readonly serviceMethod: {
      readonly region: {
        readonly regionName: string | null;
      } | null;
    } | null;
    readonly totalAmount: {
      readonly convertedAmounts: {
        readonly USD: number | null;
      } | null;
    } | null;
  } | null> | null;
  readonly vertical: VerticalType | null;
  readonly " $fragmentType": "shippingHelpers_item";
};
export type shippingHelpers_item$key = {
  readonly " $data"?: shippingHelpers_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"shippingHelpers_item">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "shippingHelpers_item"
};

(node as any).hash = "d9180e2367f1fa0805ae1d57f45065b5";

export default node;
